export default __webpack_public_path__ + "static/media/eassytoclean.07baed43.png";